var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "5f878mgv4a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 0.701961 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    filter: "url(#5f878mgv4a)",
    transform: "translate(-372.000000, -234.000000) translate(340.000000, 182.000000) translate(32.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5L7.5 1.5 7.5 0 0 0 0 7.5 1.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5V3H3v4.5h4.5zm-3-3H6V6H4.5V4.5zM14.625 0L14.625 1.5 21 1.5 21 7.5 22.5 7.5 22.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.5V3H15v4.5h4.5zm-3-3H18V6h-1.5V4.5zM1.5 15L0 15 0 22.5 7.5 22.5 7.5 21 1.5 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15H3v4.5h4.5V15h-3zM6 18H4.5v-1.5H6V18zM21 21L14.625 21 14.625 22.5 22.5 22.5 22.5 15 21 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5L18 13.5 18 16.5 19.5 16.5 19.5 12 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5L19.5 18 10.5 18 10.5 12 3 12 3 13.5 9 13.5 9 19.5zM9 3L10.5 3 10.5 7.5 9 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5L13.5 10.5 13.5 3 12 3 12 9 3 9zM15 9L19.5 9 19.5 10.5 15 10.5zM15 15L16.5 15 16.5 16.5 15 16.5zM12 15L13.5 15 13.5 16.5 12 16.5z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrCode);
export default __webpack_public_path__ + "static/media/iconQrCode.cc3d7ec7.svg";
export { ForwardRef as ReactComponent };